import React from 'react'
import { Link } from 'react-router-dom'
import './component.css'
import EnquiryForm from './EnquiryForm'


const contact = () => {
    return (
        <><div className="container ">
            <div className="text-dark bg-primary py-3 mt-1 text-center">
                <h4> From a simple query to many complex questions regarding your next big project, we are here to help you. </h4>
                <h4 className='text-white'>Our Delhi Location</h4>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.797845226352!2d77.27926552528916!3d28.63582027566301!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa9d85eeaa8608fad%3A0xd2fa70ebbac04db3!2sE%20Seller%20Support%20(Amazon%20Spn%20Authorized%20Service%20Provider)!5e0!3m2!1sen!2sin!4v1740319994733!5m2!1sen!2sin" width="100%" height="300" className='p-3 ' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
            <div className='container'>
                <div className="row py-3 m-3">
                    <div className="col-sm">
                        <p><h2>Contact Details</h2></p>
                        <p><b>Business Enquiry:</b><Link to="tel:+91 8527203697"> +91 8527203697</Link><br />
                            <b>Human Resource: </b>  <Link to="+91 9654190267">+91 9654190267</Link> <br /></p>
                        <div className="line-sep">
                        </div>
                        <p>
                            info@esellersupport.in(For Seller enquiry)</p>
                        <div className="line-sep">
                        </div>
                        <p>E-42/B, Ground Floor, near Hira Sweets, Jawahar Park, Block E, Laxmi Nagar, New Delhi, Delhi, 110092</p>
                        <div className="line-sep">
                        </div>
                        <p>Mon – Sat<br />
                            10 am to 7 pm</p>
                        <div className="line-sep">
                        </div>
                    </div>
                    <div className="col-sm ">
                        <EnquiryForm />
                    </div>
                </div >
            </div>
        </>
    )
}

export default contact
